import { render, staticRenderFns } from "./seoForm.vue?vue&type=template&id=967345a4&scoped=true&"
import script from "./seoForm.vue?vue&type=script&lang=js&"
export * from "./seoForm.vue?vue&type=script&lang=js&"
import style0 from "./seoForm.vue?vue&type=style&index=0&id=967345a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967345a4",
  null
  
)

export default component.exports